import { catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import Actions from '../actions'
import $t from '../i18n'

export const CUSTOME_ERRORS = {
  'There was a problem during signup': $t('errors.usedCredential'),
  'register pending has an error': $t('errors.phoneInvalid'),
  'Sorry! wrong code': $t('errors.wrongCodeEntered'),
  'Email Not verified yet': $t('errors.emailNotVerified'),
  'Unable to log in with provided credentials.': $t(
    'errors.FailedRegistration'
  ),
  'Login failed': $t('errors.FailedRegistration'),
  'Coupon not valid': $t('errors.couponError'),
  'Update email error': $t('errors.updateEmailFailed'),
  'Update phone error': $t('errors.updatePhoneFailed'),
  'Error in check new phone': $t('errors.updatePhoneFailed'),
  'Max login attempts exceeded.': $t('errors.maxLoginAttemptsExceeded'),
  'Landline sms error': $t('errors.landLineSmsError'),
}

export const translateErrorMsg = error => {
  if (CUSTOME_ERRORS.hasOwnProperty(error?.body?.message)) {
    error.message = CUSTOME_ERRORS[error?.body?.message]
  } else if (CUSTOME_ERRORS.hasOwnProperty(error?.body?.non_field_errors)) {
    error.message = CUSTOME_ERRORS[error?.body?.non_field_errors?.[0]]
  } else {
    error.message = $t('errors.somethingWentWrong')
  }
  return { error }
}

export const catchAndCancelActions = cancelActions =>
  catchError(error => {
    console.error(error)
    return of(
      Actions.createAction(Actions.OPERATION_FAILED, translateErrorMsg(error)),
      ...cancelActions
    )
  })

export const catchAndDispatchCustomError = catchError(error => {
  console.error(error)

  return of(Actions.createAction(Actions.OPERATION_FAILED, { error }))

  // if (error.body?.message === 'These credentials were already used') {
  //   if (error.body.error_fields) {
  //     const payload = error.body
  //     return of(Actions.createAction(Actions.ADD_NEW_MEMBER_ERRORS, payload))
  //   } else {
  //     return of(Actions.createAction(Actions.ADD_NEW_MEMBER_ERRORS))
  //   }
  // } else {
  //   return of(Actions.createAction(Actions.OPERATION_FAILED, { error }))
  // }
})
